import { render, staticRenderFns } from "./link-applications.vue?vue&type=template&id=47c05b6a&scoped=true"
import script from "./link-applications.vue?vue&type=script&lang=js"
export * from "./link-applications.vue?vue&type=script&lang=js"
import style0 from "./link-applications.vue?vue&type=style&index=0&id=47c05b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c05b6a",
  null
  
)

export default component.exports